import { render } from "./Create.vue?vue&type=template&id=48d6a9cb&bindings={\"errors\":\"props\",\"timezones\":\"props\",\"form\":\"data\",\"create\":\"options\"}"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "48d6a9cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48d6a9cb')) {
    api.reload('48d6a9cb', script)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=48d6a9cb&bindings={\"errors\":\"props\",\"timezones\":\"props\",\"form\":\"data\",\"create\":\"options\"}", () => {
    api.rerender('48d6a9cb', render)
  })

}

script.__file = "resources/js/Pages/Tenants/Create.vue"

export default script